export interface AppConfig {
  Api: string;
  Themes: ThemesConfig;
  DefaultTheme: ThemeConfig;
  LocalStorage: string;
  Files: string;
  VideoBaseUrl: string;
  VideoBaseExtension: string;
}

export interface ThemeConfig {
  component: string;
  name: string;
  title: string;
}

export interface ThemesConfig {
  [key: string]: ThemeConfig;
}

const defaultTheme: ThemeConfig = {
  component: "DefaultTheme.vue",
  name: "cert",
  title: "CCAT | Common Core Assessment Tool",
};

const themes: ThemesConfig = {
  ["localhost:8181"]: {
    component: "CollegePrepAlabama.vue",
    name: "cpa",
    title: "College Prep Alabama",
  },
  ["cpa-student-stage.ccatforschools.com"]: {
    component: "CollegePrepAlabama.vue",
    name: "cpa",
    title: "College Prep Alabama",
  },
  ["testing.collegeprepalabama.com"]: {
    component: "CollegePrepAlabama.vue",
    name: "cpa",
    title: "College Prep Alabama",
  },
};

const Config: AppConfig = {
  Api: process.env.VUE_APP_API,
  Themes: themes,
  DefaultTheme: defaultTheme,
  LocalStorage: process.env.VUE_APP_LOCAL_STORAGE,
  Files: process.env.VUE_APP_API_FILE,
  VideoBaseUrl: process.env.VUE_APP_VIDEO_BASE_URL,
  VideoBaseExtension: process.env.VUE_APP_VIDEO_BASE_EXT,
};

export { Config };

export default {
  install(Vue: any) {
    Vue.AppConfig = Config;
    Vue.prototype.$AppConfig = Config;
  },
};
